// Bilingual strings (Greek default, English secondary)
export const translations = {
  el: {
    brand: "Dikigoros.io",
    nav: {
      features: "Δυνατότητες",
      how: "Πώς λειτουργεί",
      pricing: "Τιμές",
      login: "Σύνδεση",
      signup: "Δωρεάν έναρξη",
      dashboard: "Πίνακας",
      logout: "Αποσύνδεση",
    },
    landing: {
      heroKicker: "AI νομικός βοηθός για την Κύπρο",
      heroTitle: "Από τα γεγονότα στη δομημένη ανάλυση. Σε 90 δευτερόλεπτα.",
      heroTitleA: "Από τα γεγονότα στη ",
      heroTitleAccent: "δομημένη ανάλυση",
      heroTitleB: ". Σε ",
      heroTitleAccent2: "90 δευτερόλεπτα",
      heroTitleC: ".",
      heroSubtitle: "Ανεβάστε τα γεγονότα και τα έγγραφα της υπόθεσης. Λαμβάνετε επαγγελματική αναφορά 11 ενοτήτων, βασισμένη στο κυπριακό δίκαιο και τη νομολογία. Έτοιμη για το γραφείο σας.",
      heroCta: "Δοκιμάστε δωρεάν",
      heroSecondary: "Δείτε δείγμα ανάλυσης",
      heroTrust: "Σχεδιασμένο για δικηγόρους και δικηγορικά γραφεία στην Λευκωσία, Λεμεσό, Λάρνακα και Πάφο.",
      valueKicker: "Γιατί το Dikigoros.io",
      valueTitle: "Επαγγελματικό αποτέλεσμα. Δομημένη ανάλυση από AI νομικό βοηθό.",
      value1Title: "Δομημένη αναφορά 11 ενοτήτων",
      value1Desc: "Εκτελεστική περίληψη, εφαρμοστέο κυπριακό δίκαιο, νομολογία, κίνδυνοι και επόμενα βήματα. Κάθε φορά, με την ίδια αυστηρή δομή.",
      value2Title: "Εστίαση στο κυπριακό δίκαιο",
      value2Desc: "Βασίζεται σε πρωτογενή κυπριακή νομοθεσία, στο Σύνταγμα και στη σχετική νομολογία. Όχι σε γενικές απαντήσεις.",
      value3Title: "Ασφάλεια επιχειρηματικής κλάσης",
      value3Desc: "Κρυπτογραφημένες συνδέσεις, ιδιωτική αποθήκευση εγγράφων, αυστηρές πολιτικές πρόσβασης.",
      value4Title: "Ομαδικός χώρος υπόθεσης",
      value4Desc: "Οργανώστε γεγονότα, έγγραφα και αναλύσεις ανά υπόθεση, με ετικέτες και πλήρες ιστορικό.",
      howKicker: "Πώς λειτουργεί",
      howTitle: "Τρία απλά βήματα προς δομημένη νομική ανάλυση",
      how1: "Περιγράψτε τα γεγονότα και το ερώτημα",
      how1d: "Καταχωρίστε το σύντομο ιστορικό και το νομικό σας ερώτημα. Μεταφορτώστε έγγραφα (PDF, DOCX, TXT).",
      how2: "Ο AI νομικός βοηθός αναλύει",
      how2d: "Εντοπίζει εφαρμοστέους νόμους, νομολογία, κινδύνους και πιθανά αντεπιχειρήματα.",
      how3: "Λάβετε δομημένη αναφορά",
      how3d: "Μια επαγγελματική αναφορά 11 ενοτήτων, έτοιμη για αναθεώρηση, εξαγωγή και χρήση.",
      outputKicker: "Δείγμα αποτελέσματος",
      outputTitle: "Κάθε ανάλυση, η ίδια αυστηρή δομή",
      outputSub: "Επαγγελματικό νομικό αποτέλεσμα: δομημένο, αναφορικό και έτοιμο για αναθεώρηση από τον δικηγόρο.",
      useCasesKicker: "Περιπτώσεις χρήσης",
      useCasesTitle: "Δοκιμασμένο σε πραγματικά σενάρια κυπριακής πρακτικής",
      uc1: "Εταιρικό και εμπορικό δίκαιο",
      uc1d: "Ανάλυση συμβάσεων, εταιρικών διαφορών και καταστατικών εγγράφων.",
      uc2: "Εργατικό δίκαιο",
      uc2d: "Καταγγελίες απόλυσης, διακρίσεις, ώρες εργασίας και αποζημιώσεις.",
      uc3: "Ακίνητη ιδιοκτησία",
      uc3d: "Μεταβιβάσεις, τίτλοι ιδιοκτησίας, μισθώσεις και δουλείες.",
      uc4: "Οικογενειακό δίκαιο",
      uc4d: "Διαζύγια, διατροφές, επιμέλεια, συναινετικές συμφωνίες.",
      uc5: "Ποινικό δίκαιο",
      uc5d: "Πρώτη ανάλυση κατηγορητηρίου, υπερασπιστικά επιχειρήματα, νομολογία.",
      uc6: "Συμβατικές διαφορές",
      uc6d: "Παραβάσεις, αποζημιώσεις, ρήτρες και ασφαλιστικά μέτρα.",
      pricingKicker: "Τιμές",
      pricingTitle: "Διαφανής τιμολόγηση. Χωρίς εκπλήξεις.",
      pricingMonthly: "Μηνιαία",
      pricingYearly: "Ετήσια (−17%)",
      pricingFreeName: "Δωρεάν",
      pricingStarter: "Starter",
      pricingPro: "Professional",
      pricingEnterprise: "Enterprise",
      pricingPerMonth: "/ μήνα",
      pricingPerYear: "/ έτος",
      pricingFreeCta: "Ξεκινήστε δωρεάν",
      pricingStarterCta: "Επιλογή Starter",
      pricingProCta: "Επιλογή Professional",
      pricingEnterpriseCta: "Επικοινωνήστε μαζί μας",
      ctaTitle: "Έτοιμοι να δοκιμάσετε το Dikigoros.io;",
      ctaSubtitle: "Ξεκινήστε δωρεάν. Χωρίς πιστωτική κάρτα. Διαθέσιμο στα ελληνικά και στα αγγλικά.",
      ctaButton: "Δημιουργία λογαριασμού",
      planFeaturesFree: [
        "Δωρεάν 2 εβδομάδες Professional",
        "3 μονάδες AI / μήνα μετά",
        "Αναζήτηση νομοθεσίας και υποθέσεων",
        "Σύνταξη νομικών προτύπων",
        "Έως 4 ενεργές υποθέσεις",
      ],
      planFeaturesStarter: [
        "25 μονάδες AI / μήνα",
        "Βασική νομική ανάλυση με AI",
        "Αναζήτηση νομοθεσίας και υποθέσεων",
        "Σύνταξη νομικών προτύπων",
        "Υποστήριξη κατά προτεραιότητα",
      ],
      planFeaturesPro: [
        "75 μονάδες AI / μήνα",
        "Πλήρης ανάλυση και εμβάθυνση",
        "Μεταφόρτωση αρχείων (PDF / DOCX)",
        "Σύνταξη υπομνημάτων και αγορεύσεων",
        "Απεριόριστες ενεργές υποθέσεις",
        "Εξαγωγή ιστορικού (PDF και DOCX)",
      ],
      planFeaturesEnterprise: [
        "200 μονάδες AI / μήνα",
        "Όλα τα χαρακτηριστικά του Professional",
        "Μεταφόρτωση αρχείων",
        "Πρόσβαση μέσω API",
        "Αποκλειστικός διαχειριστής λογαριασμού",
        "Προσαρμοσμένες ενσωματώσεις",
      ],
    },
    auth: {
      loginTitle: "Σύνδεση στο Dikigoros.io",
      loginSub: "Καλωσορίσατε ξανά.",
      email: "Διεύθυνση email",
      password: "Κωδικός",
      submit: "Σύνδεση",
      forgot: "Ξεχάσατε τον κωδικό;",
      noAccount: "Δεν έχετε λογαριασμό;",
      signupHere: "Εγγραφή εδώ",
      signupTitle: "Δημιουργία λογαριασμού",
      signupSub: "Ξεκινήστε δωρεάν. Χωρίς πιστωτική κάρτα.",
      fullName: "Ονοματεπώνυμο",
      firm: "Δικηγορικό γραφείο (προαιρετικό)",
      create: "Δημιουργία λογαριασμού",
      hasAccount: "Έχετε ήδη λογαριασμό;",
      loginHere: "Σύνδεση εδώ",
      forgotTitle: "Επαναφορά κωδικού",
      forgotSub: "Θα λάβετε email με οδηγίες.",
      sendLink: "Αποστολή συνδέσμου",
      resetTitle: "Νέος κωδικός",
      resetSub: "Ορίστε έναν νέο κωδικό για τον λογαριασμό σας.",
      newPw: "Νέος κωδικός",
      reset: "Ενημέρωση κωδικού",
      verifyTitle: "Επιβεβαίωση email",
    },
    dash: {
      welcome: "Καλώς ήρθατε",
      newAnalysis: "Νέα ανάλυση",
      recent: "Πρόσφατες υποθέσεις",
      noMatters: "Δεν υπάρχουν υποθέσεις ακόμα.",
      createFirst: "Δημιουργήστε την πρώτη σας υπόθεση",
      usage: "Χρήση",
      plan: "Συνδρομή",
      upgrade: "Αναβάθμιση",
      matters: "Υποθέσεις",
      analyses: "Αναλύσεις",
    },
    matter: {
      createTitle: "Νέα υπόθεση",
      title: "Τίτλος υπόθεσης",
      facts: "Γεγονότα & ιστορικό",
      tags: "Ετικέτες (χωρισμένες με κόμμα)",
      save: "Αποθήκευση",
      tabFacts: "Γεγονότα",
      tabDocs: "Έγγραφα",
      tabOutputs: "Αναλύσεις",
      uploadDoc: "Μεταφόρτωση εγγράφου",
      runAnalysis: "Εκτέλεση ανάλυσης",
      question: "Νομικό ερώτημα",
      generate: "Παραγωγή ανάλυσης",
      generating: "Εκτελείται ανάλυση…",
      empty: "Δεν υπάρχουν αναλύσεις. Εκτελέστε την πρώτη σας.",
      noDocs: "Δεν έχουν ανέβει έγγραφα.",
      includeDocs: "Συμπερίληψη εγγράφων",
    },
    report: {
      executive_summary: "Εκτελεστική Περίληψη",
      facts: "Γεγονότα",
      legal_issues: "Νομικά Ζητήματα",
      applicable_cyprus_law: "Εφαρμοστέο Κυπριακό Δίκαιο",
      case_law: "Νομολογία",
      analysis: "Ανάλυση",
      counterarguments: "Αντεπιχειρήματα",
      risks: "Κίνδυνοι",
      next_steps: "Επόμενα Βήματα",
      sources: "Πηγές",
      disclaimer: "Αποποίηση Ευθύνης",
      confidence: "Βαθμός βεβαιότητας",
      uncertaintyNotes: "Σημειώσεις αβεβαιότητας",
      share: "Κοινοποίηση",
      shared: "Δημόσιο",
      publicLink: "Δημόσιος σύνδεσμος",
      copy: "Αντιγραφή",
      copied: "Αντιγράφηκε",
      shareEnabled: "Ο δημόσιος σύνδεσμος ενεργοποιήθηκε",
      shareRevoked: "Ο δημόσιος σύνδεσμος ανακλήθηκε",
      shareError: "Η κοινοποίηση απέτυχε",
      copyError: "Η αντιγραφή απέτυχε",
      copyHint: "Πατήστε Ctrl+C για αντιγραφή",
    },
    billing: {
      title: "Επιλέξτε το πλάνο σας",
      currentPlan: "Τρέχον πλάνο",
      choose: "Επιλογή",
      mostPopular: "Πιο δημοφιλές",
      billingMonthly: "/ μήνα",
      billingYearly: "/ έτος",
      successTitle: "Η πληρωμή ολοκληρώθηκε",
      successSub: "Ευχαριστούμε! Η συνδρομή σας είναι ενεργή.",
      checking: "Επαλήθευση πληρωμής…",
      goDash: "Μετάβαση στον Πίνακα",
    },
    admin: {
      title: "Πίνακας Διαχείρισης",
      users: "Χρήστες",
      matters: "Υποθέσεις",
      reports: "Αναλύσεις",
      emails: "Emails",
      subs: "Συνδρομές",
      mrr: "MRR (€)",
      tabsUsers: "Χρήστες",
      tabsEmails: "Logs Email",
      tabsPayments: "Πληρωμές",
      tabsUsage: "Χρήση",
    },
    common: {
      cancel: "Ακύρωση",
      save: "Αποθήκευση",
      delete: "Διαγραφή",
      back: "Πίσω",
      loading: "Φόρτωση…",
      success: "Επιτυχία",
      error: "Σφάλμα",
    },
  },
  en: {
    brand: "Dikigoros.io",
    nav: {
      features: "Features",
      how: "How it works",
      pricing: "Pricing",
      login: "Sign in",
      signup: "Start free",
      dashboard: "Dashboard",
      logout: "Log out",
    },
    landing: {
      heroKicker: "AI legal assistant for Cyprus",
      heroTitle: "From facts to a structured analysis. In 90 seconds.",
      heroTitleA: "From facts to a ",
      heroTitleAccent: "structured analysis",
      heroTitleB: ". In ",
      heroTitleAccent2: "90 seconds",
      heroTitleC: ".",
      heroSubtitle: "Upload the facts and documents of the matter. Receive a professional 11-section report grounded in Cyprus law and case law. Ready for your firm.",
      heroCta: "Try it free",
      heroSecondary: "See sample analysis",
      heroTrust: "Built for lawyers and law firms in Nicosia, Limassol, Larnaca and Paphos.",
      valueKicker: "Why Dikigoros.io",
      valueTitle: "Professional output. Not endless conversation.",
      value1Title: "Structured 11-section report",
      value1Desc: "Executive summary, applicable Cyprus law, case law, risks and next steps. Every time, same rigorous structure.",
      value2Title: "Cyprus-first",
      value2Desc: "Grounded in primary Cyprus legislation, the Constitution and relevant case law. Not generic answers.",
      value3Title: "Enterprise-grade security",
      value3Desc: "Encrypted sessions, private document storage, strict access policies.",
      value4Title: "Matter workspace",
      value4Desc: "Organise facts, documents and analyses per matter, with tags and history.",
      howKicker: "How it works",
      howTitle: "Three simple steps to structured legal analysis",
      how1: "Describe facts & question",
      how1d: "Enter a brief history and your legal question. Upload documents (PDF, DOCX, TXT).",
      how2: "The engine analyses",
      how2d: "It identifies applicable laws, case law, risks and counterarguments.",
      how3: "Get a structured report",
      how3d: "A professional 11-section report, ready for review, export and delivery.",
      outputKicker: "Sample output",
      outputTitle: "Every analysis, same rigorous structure",
      outputSub: "Professional legal work product: structured, referenced and ready for your review.",
      useCasesKicker: "Use cases",
      useCasesTitle: "Tested on real Cyprus practice scenarios",
      uc1: "Corporate & Commercial",
      uc1d: "Contract analysis, corporate disputes, constitutional documents.",
      uc2: "Employment",
      uc2d: "Wrongful dismissal, discrimination, working hours, compensation.",
      uc3: "Real Estate",
      uc3d: "Transfers, title deeds, leases and easements.",
      uc4: "Family Law",
      uc4d: "Divorce, maintenance, custody, consent agreements.",
      uc5: "Criminal Law",
      uc5d: "Initial charge sheet analysis, defence arguments, case law.",
      uc6: "Contract Disputes",
      uc6d: "Breach, damages, clauses and injunctions.",
      pricingKicker: "Pricing",
      pricingTitle: "Transparent pricing. No surprises.",
      pricingMonthly: "Monthly",
      pricingYearly: "Yearly (−17%)",
      pricingFreeName: "Free",
      pricingStarter: "Starter",
      pricingPro: "Professional",
      pricingEnterprise: "Enterprise",
      pricingPerMonth: "/ mo",
      pricingPerYear: "/ yr",
      pricingFreeCta: "Start Free",
      pricingStarterCta: "Choose Starter",
      pricingProCta: "Choose Professional",
      pricingEnterpriseCta: "Contact us",
      ctaTitle: "Ready to try Dikigoros.io?",
      ctaSubtitle: "Start free. No credit card. Greek & English.",
      ctaButton: "Create account",
      planFeaturesFree: [
        "2 weeks Professional free",
        "3 AI Units / month after",
        "Legislation & case-law search",
        "Drafting legal templates",
        "Up to 4 active matters",
      ],
      planFeaturesStarter: [
        "25 AI Units / month",
        "Basic AI legal analysis",
        "Legislation & case-law search",
        "Drafting legal templates",
        "Priority Live Chat",
      ],
      planFeaturesPro: [
        "75 AI Units / month",
        "Full Analysis & Deep Dive",
        "File upload (PDF/DOCX)",
        "Drafting memoranda & speeches",
        "Unlimited active matters",
        "Export history (PDF & DOCX)",
      ],
      planFeaturesEnterprise: [
        "200 AI Units / month",
        "All Professional features",
        "File upload",
        "API access",
        "Dedicated account manager",
        "Custom integrations",
      ],
    },
    auth: {
      loginTitle: "Sign in to Dikigoros.io",
      loginSub: "Welcome back.",
      email: "Email address",
      password: "Password",
      submit: "Sign in",
      forgot: "Forgot password?",
      noAccount: "No account?",
      signupHere: "Sign up here",
      signupTitle: "Create account",
      signupSub: "Start free. No credit card required.",
      fullName: "Full name",
      firm: "Law firm (optional)",
      create: "Create account",
      hasAccount: "Already have an account?",
      loginHere: "Sign in here",
      forgotTitle: "Reset password",
      forgotSub: "We'll send you an email with instructions.",
      sendLink: "Send link",
      resetTitle: "New password",
      resetSub: "Set a new password for your account.",
      newPw: "New password",
      reset: "Update password",
      verifyTitle: "Verify email",
    },
    dash: {
      welcome: "Welcome",
      newAnalysis: "New analysis",
      recent: "Recent matters",
      noMatters: "No matters yet.",
      createFirst: "Create your first matter",
      usage: "Usage",
      plan: "Plan",
      upgrade: "Upgrade",
      matters: "Matters",
      analyses: "Analyses",
    },
    matter: {
      createTitle: "New matter",
      title: "Matter title",
      facts: "Facts & history",
      tags: "Tags (comma separated)",
      save: "Save",
      tabFacts: "Facts",
      tabDocs: "Documents",
      tabOutputs: "Analyses",
      uploadDoc: "Upload document",
      runAnalysis: "Run analysis",
      question: "Legal question",
      generate: "Generate analysis",
      generating: "Analysing…",
      empty: "No analyses yet. Run your first one.",
      noDocs: "No documents uploaded.",
      includeDocs: "Include documents",
    },
    report: {
      executive_summary: "Executive Summary",
      facts: "Facts",
      legal_issues: "Legal Issues",
      applicable_cyprus_law: "Applicable Cyprus Law",
      case_law: "Case Law",
      analysis: "Analysis",
      counterarguments: "Counterarguments",
      risks: "Risks",
      next_steps: "Next Steps",
      sources: "Sources",
      disclaimer: "Disclaimer",
      confidence: "Confidence",
      uncertaintyNotes: "Uncertainty notes",
      share: "Share",
      shared: "Public",
      publicLink: "Public link",
      copy: "Copy",
      copied: "Copied",
      shareEnabled: "Public link enabled",
      shareRevoked: "Public link revoked",
      shareError: "Could not toggle sharing",
      copyError: "Copy failed",
      copyHint: "Press Ctrl+C to copy",
    },
    billing: {
      title: "Choose your plan",
      currentPlan: "Current plan",
      choose: "Choose",
      mostPopular: "Most popular",
      billingMonthly: "/ mo",
      billingYearly: "/ yr",
      successTitle: "Payment complete",
      successSub: "Thank you! Your subscription is active.",
      checking: "Verifying payment…",
      goDash: "Go to Dashboard",
    },
    admin: {
      title: "Admin Panel",
      users: "Users",
      matters: "Matters",
      reports: "Reports",
      emails: "Emails",
      subs: "Subscriptions",
      mrr: "MRR (€)",
      tabsUsers: "Users",
      tabsEmails: "Email Logs",
      tabsPayments: "Payments",
      tabsUsage: "Usage",
    },
    common: {
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      back: "Back",
      loading: "Loading…",
      success: "Success",
      error: "Error",
    },
  },
};
